import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import { getEmployeeInfo } from '@/modules/Employee/services'
import { useEmployeeUpdateTabs } from './tabs'
import ProfileHeader from './ProfileHeader'
import Paper from '@/components/Paper'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const EmployeeUpdate: React.FC = () => {
    const { id } = useParams()
    const { t } = useTranslation()

    const { data: employee, renderState } = useQueryWithHandler({
        queryFn: () => getEmployeeInfo(Number(id)),
        queryKey: [QUERY_KEYS.EMPLOYEE, id],
        enabled: !!id,
    })

    const { TabProps, TabComponent } = useTabs({
        tabs: useEmployeeUpdateTabs(),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <>
            <SubHeaders
                className="!pb-0"
                breadcrumbs={[
                    {
                        path: paths.employeesManage,
                        title: t('employee-manage'),
                    },
                    {
                        path: generatePathDatacentral(paths.employeeUpdate, {
                            id,
                        }),
                        title: `#${id}`,
                    },
                    {
                        path: generatePathDatacentral(paths.employeeUpdate, {
                            id,
                        }),
                        title: t('edit'),
                    },
                ]}
            />

            <div className="min-h-screen">
                <div className="grid grid-cols-12 gap-4 h-full">
                    <div className="col-span-12 md:col-span-3 pt-2">
                        {employee?.result && (
                            <ProfileHeader employee={employee.result} />
                        )}
                    </div>
                    <div className="col-span-12 md:col-span-9">
                        <Tabs {...TabProps} className="mb-2 mt-0" />
                        <Paper className="mt-2">{TabComponent}</Paper>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EmployeeUpdate
